var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#B5E2F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.271 20.396V20.896H32.771H36.7085C36.8472 20.896 36.9585 21.0073 36.9585 21.146V24.771H19.2085V21.146C19.2085 21.0073 19.3198 20.896 19.4585 20.896H23.396H23.896V20.396V19.2085H24.5835V20.396V20.896H25.0835H31.0835H31.5835V20.396V19.2085H32.271V20.396ZM19.4585 36.9585C19.3198 36.9585 19.2085 36.8472 19.2085 36.7085V27.3647H36.9585V36.7085C36.9585 36.8472 36.8472 36.9585 36.7085 36.9585H19.4585Z",
    fill: "#00B3FF",
    stroke: "#20AFEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueContainer);
export default __webpack_public_path__ + "static/media/blue-container.9fd3a2522cc5deff008745a88a7d4a12.svg";
export { ForwardRef as ReactComponent };